export const log = (...args) => ({
	color: (color = 'transparent', includeTimestamp = false) => {
		const timestamp = includeTimestamp ? new Date().toLocaleTimeString() + ':' + new Date().getMilliseconds() : ''
		const prefix = includeTimestamp ? '%c' + timestamp + '  %c' : '%c'
		const styles = includeTimestamp ? ['color:#999; font-weight: normal', 'background: ' + color + '; color: black; padding: 2px; font-weight: normal;'] : ['background: ' + color + '; color: black; padding: 2px; font-weight: normal;']
		console.groupCollapsed(prefix + args[0], ...styles, ...args.slice(1))
		console.trace()
		console.groupEnd()
	},
	white: (includeTimestamp = false) => {
		const timestamp = includeTimestamp ? new Date().toLocaleTimeString() + ':' + new Date().getMilliseconds() : ''
		const prefix = includeTimestamp ? '%c' + timestamp + '  %c' : '%c'
		const styles = includeTimestamp ? ['color:white; font-weight: normal', 'background: white; color: black; padding: 2px; font-weight: normal;'] : ['background: #FFFFFF; color: black; padding: 2px; font-weight: normal;']
		console.warn(prefix + args[0], ...styles, ...args.slice(1))
	},
	yellow: (includeTimestamp = false) => {
		const timestamp = includeTimestamp ? new Date().toLocaleTimeString() + ':' + new Date().getMilliseconds() : ''
		const prefix = includeTimestamp ? '%c' + timestamp + '  %c' : '%c'
		const styles = includeTimestamp ? ['color:white; font-weight: normal', 'background: #FFFF00; color: black; padding: 2px; font-weight: normal;'] : ['background: #FFFF00; color: black; padding: 2px; font-weight: normal;']
		console.warn(prefix + args[0], ...styles, ...args.slice(1))
	},
	red: (includeTimestamp = false) => {
		const timestamp = includeTimestamp ? new Date().toLocaleTimeString() + ':' + new Date().getMilliseconds() : ''
		const prefix = includeTimestamp ? '%c' + timestamp + '  %c' : '%c'
		const styles = includeTimestamp ? ['color:white; font-weight: normal', 'background: #FF0000; color: white; padding: 2px; font-weight: normal;'] : ['background: #FF0000; color: white; padding: 2px; font-weight: normal;']
		console.warn(prefix + args[0], ...styles, ...args.slice(1))
	},
	green: (includeTimestamp = false) => {
		const timestamp = includeTimestamp ? new Date().toLocaleTimeString() + ':' + new Date().getMilliseconds() : ''
		const prefix = includeTimestamp ? '%c' + timestamp + '  %c' : '%c'
		const styles = includeTimestamp ? ['color:white; font-weight: normal', 'background: #009900; color: black; padding: 2px; font-weight: normal;'] : ['background: #009900; color: white; padding: 2px; font-weight: normal;']
		console.warn(prefix + args[0], ...styles, ...args.slice(1))
	},
	blue: (includeTimestamp = false) => {
		const timestamp = includeTimestamp ? new Date().toLocaleTimeString() + ':' + new Date().getMilliseconds() : ''
		const prefix = includeTimestamp ? '%c' + timestamp + '  %c' : '%c'
		const styles = includeTimestamp ? ['color:white; font-weight: normal', 'background: #0000DD; color: black; padding: 2px; font-weight: normal;'] : ['background: #0000DD; color: white; padding: 2px; font-weight: normal;']
		console.warn(prefix + args[0], ...styles, ...args.slice(1))
	},
	purple: (includeTimestamp = false) => {
		const timestamp = includeTimestamp ? new Date().toLocaleTimeString() + ':' + new Date().getMilliseconds() : ''
		const prefix = includeTimestamp ? '%c' + timestamp + '  %c' : '%c'
		const styles = includeTimestamp ? ['color:white; font-weight: normal', 'background: #800080; color: black; padding: 2px; font-weight: normal;'] : ['background: #800080; color: white; padding: 2px; font-weight: normal;']
		console.warn(prefix + args[0], ...styles, ...args.slice(1))
	},
})

// Export an empty object (overloading is already done)
export default {
	log,
}
